// #region Imports
import '../classes/MenuEntries';
// #endregion
const navigationModule = {
    // #region Vars
    namespaced: true,
    // #endregion
    // #region Properties
    state: {
        mainMenu: [],
        breadcrumb: [],
        cachedMenu: new Map(),
        banner: [],
    },
    // #endregion
    // #region getter
    getters: {
        getStickyBar(state) {
            return state.stickyBar;
        },
        getMenu(state) {
            return (name) => {
                return state.mainMenu.find((e) => e.menuID === name)?.children ?? new Array();
            };
        },
        getCachedMenu(state) {
            return async (name) => {
                //Data
                let tCache = state.cachedMenu;
                //Exists
                if (tCache.has(name)) {
                    return tCache.get(name);
                }
                //Fill
                let tResult = await host.api.get(`/system/app/navigation/${name}`);
                if (!tResult.data) {
                    tCache.set(name, []);
                    return [];
                }
                //Data
                tCache.set(name, tResult.data.children);
                return tResult.data.children;
            };
        },
        getBreadcrumb(state) {
            return state.breadcrumb;
        }
    },
    // #endregion
    // #region Mutations
    mutations: {
        startup(state, host) {
            host.store.subscribe((m, s) => {
                if (m.type === "session/loggedIn") {
                    host.store.commit('navigation/load', m.payload);
                }
                if (m.type === "session/loggedOut") {
                    host.store.commit('navigation/load', m.payload);
                }
                if (m.type === "session/anonymous") {
                    host.store.commit('navigation/load', m.payload);
                }
            });
        },
        setMenu(state, menu) {
            state.mainMenu = menu;
        },
        setBanner(state, menu) {
            state.banner = menu;
        },
        load(state) {
            host.api.get("system/app/navigation").then((r) => {
                state.mainMenu = r.data;
            });
        },
        setBreadcrumb(state, data) {
            state.breadcrumb = data;
        }
    },
    // #endregion
};
export default navigationModule;
